<template>
  <div class="topup-energy">
    <topup-energy-breadcrumbs />
    <topup-energy-modal v-if="isModalVisible" />
    <topup-energy-step1 v-if="isStep1" />
    <topup-energy-step2 v-if="isStep2" />
  </div>
</template>

<script>
import TopupEnergyBreadcrumbs from '@/doladujtutaj/components/TopupEnergy/Breadcrumbs'
import TopupEnergyStep1 from '@/doladujtutaj/components/TopupEnergy/Step1'
import TopupEnergyStep2 from '@/doladujtutaj/components/TopupEnergy/Step2'
import { mapState } from 'vuex'
import { ToolsClass } from '@/common/class/tools.class'
import TopupEnergyModal from '@/doladujtutaj/components/TopupEnergy/Modal'

export default {
  name: 'TopupEnergyView',
  components: {
    TopupEnergyModal,
    TopupEnergyBreadcrumbs,
    TopupEnergyStep1,
    TopupEnergyStep2
  },
  computed: {
    ...mapState({
      calculationData: state => state.energy.calculationData,
      calculationStatus: state => state.energy.calculationStatus,
      isModalVisible: state => state.energy.modal.visible
    }),
    isStep1: function () {
      return this.calculationData === null
    },
    isStep2: function () {
      return this.calculationData !== null
    }
  },
  mounted () {
    ToolsClass.sendHeightToIframeParent()
    window.addEventListener('resize', ToolsClass.sendHeightToIframeParent)
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
